import { useState, useEffect } from 'react'
import CustomTableLayout from '../../../components/CustomComponents/CustomTableLayout'
import { formatDate, getAllData, subtractDays } from '../../../shared/constants'

const ArchievedReport = () => {
  const [state, setState] = useState({
    data: [],
    loading: false,
    paginate: false,
    downloadData: false,
  })

  const filterData = state.data
  const [page, setPage] = useState(1)

  //? useEffect
  useEffect(() => {
    getAllData('GET_ARCHIEVED_REPORT', { page: page, limit: 10 }, state, setState)
  }, [page])

  const handleChange = (event, value) => {
    setPage(value)
  }

  let tableBody = []

  console.log({ filterData })
  console.log({ state })

  if (!state.loading && filterData.length > 0) {
    tableBody = filterData.map((item, index) => {
      return [
        { value: index + 1 },
        { value: item.contentType == '' ? 'N/A' : item.contentType.split('').join('') },
        { value: item.expiryDate },
        { value: item.startDate },
        { value: item.category },
        { value: item.createdAt },
      ]
    })
  }

  const layoutProps = {
    heading: 'Archieved Report',
    filename: 'archievedReport',
    headers: state.downloadData.headings,
    data: state.downloadData.headingValues,
  }

  return (
    <CustomTableLayout
      tableHeadings={['S No.', 'Type', 'Expiry Date', 'Start Date', 'Category', 'Created At']}
      loading={state.loading}
      tableBody={tableBody}
      handlePageChange={handleChange}
      paginate={{ totalPage: state.paginate.totalPage, page: page }}
      layoutProps={layoutProps}
    />
  )
}

export default ArchievedReport
